import React from "react";
import { default as MuiBackdrop } from "@mui/material/Backdrop";

function Backdrop(props) {
  return <MuiBackdrop {...props} />;
}

export default Backdrop;
